import { render, staticRenderFns } from "./cmp-explorer-md-attr-panel.vue?vue&type=template&id=1811dc61&scoped=true&"
import script from "./cmp-explorer-md-attr-panel.vue?vue&type=script&lang=ts&"
export * from "./cmp-explorer-md-attr-panel.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-explorer-md-attr-panel.vue?vue&type=style&index=0&id=1811dc61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811dc61",
  null
  
)

/* custom blocks */
import block0 from "./cmp-explorer-md-attr-panel.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports